import Vue from 'vue'
import App from './App.vue'
// import '@/permission' // permission control
import router from './router'
import store from './store'
import './assets/fonts/iconfont.css'
import './assets/iconfont/iconfont.css'
import './plugins/element.js'
import '@/styles/index.scss' // global css
import { Message, MessageBox } from 'element-ui'
import _ from 'lodash'
import qs from 'qs'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import { parseTime } from './commons/index'
import myUtils from './utils/myUtils'
import moment from 'moment'
import globalEnum from './config/globalEnum'
//  引入 axios插件
import './plugins/axios'
import * as validate from './utils/validate'
import * as globalParams from './config/globalParams'
import './utils/globalFilters.js'

// 启用vue-devtools浏览器插件
Vue.config.devtools = true
// Vue.config.productionTip = false

Vue.prototype.$Message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$filterTime = parseTime
Vue.prototype._ = _
Vue.prototype.moment = moment
Vue.prototype.utils = myUtils
Vue.prototype.qs = qs
Vue.prototype.$enum = globalEnum
Vue.prototype.$valid = validate
Vue.prototype.$params = globalParams
Vue.filter('dateFormat', function (originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
